// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_hf-0";
export var optionCard = "_hf-1";